import { render } from "./EnrollEmailView.vue?vue&type=template&id=60bd060e"
import script from "./EnrollEmailView.vue?vue&type=script&lang=js"
export * from "./EnrollEmailView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__